import Vue from 'vue';
import Vuex from 'vuex';
import page from './modules/page';
import auth from './modules/auth';
import user from './modules/user';
import mapLayer from './modules/map-layer';
import post from './modules/post';
import tool from './modules/tool';
import file from './modules/file';
import report from './modules/report';
import point from './modules/point';
import data from './modules/data';
import flood from './modules/flood';
import statistic from './modules/statistic';
import photo from './modules/photo';
import config from './modules/config';
import feedback from './modules/feedback';
import news from './modules/news';
import group from './modules/group-user';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        page,
        auth,
        user,
        mapLayer,
        post,
        tool,
        file,
        report,
        point,
        data,
        flood,
        photo,
        config,
        statistic,
        feedback,
        news,
        group,
    },
    strict: debug
});
